import arrow from '@/assets/img/apart/apart-arrow.png'
import icon3 from '@/assets/img/apart/apart-ico-apart.png'
import icon1 from '@/assets/img/apart/apart-ico-call.png'
import icon4 from '@/assets/img/apart/apart-ico-car.png'
import icon2 from '@/assets/img/apart/apart-ico-paper.png'
import { Apart3Step } from '@/styles/Web/Apart/apart3step_styled'
import { Apart3StepContents } from '@/styles/Web/Apart/apart3step_styled'
import { ApartLayout } from '@/styles/Web/Apart/styled'

const StepData = {
  content: [
    {
      title: 'STEP 1',
      text: '오토콜 서비스 <br/> 전화 상담 진행',
      img: `${icon1}`,
    },
    {
      title: 'STEP 2',
      text: '현장 방문 및 계약 진행',
      img: `${icon2}`,
    },
    {
      title: 'STEP 3',
      text: '스티커 맞춤 제작 <br/> 관리사무소 배치',
      img: `${icon3}`,
    },
    {
      title: 'STEP 4',
      text: '입주민 스티커 수령 후 <br/> 안심주차 서비스 이용',
      img: `${icon4}`,
    },
  ],
}

const Apart3StepSection = () => {
  return (
    <Apart3Step>
      <ApartLayout>
        <div className="title">
          <h1>
            오토콜 도입 문의 후, <br />
          </h1>
        </div>
        <Apart3StepContents>
          {StepData.content.map((option, index) => (
            <section key={index}>
              <div>
                <img src={option.img} alt="" />
              </div>
              <div>
                <span>
                  <span>{option.title}</span>
                  <img className={`${index === 3 && 'arrow_hide'}`} src={arrow} alt="" />
                </span>
                <p dangerouslySetInnerHTML={{ __html: option.text ?? '' }} />
              </div>
            </section>
          ))}
        </Apart3StepContents>
      </ApartLayout>
    </Apart3Step>
  )
}
export default Apart3StepSection
